import ListPagination from './ListPagination';

export default ListPagination;
